import application from './application'
import educationLevels from './education-levels'
import employments from './employments'
import experiences from './experiences'
import gamingJobSuggestions from './gaming-job-suggestions'
import gigCategories from './gig-categories'
import gigDisputes from './gig-disputes'
import gigListings from './gig-listings'
import gigNegotiations from './gig-negotiations'
import gigProposalPayouts from './gig-proposal-payouts'
import gigReviewContests from './gig-review-contests'
import gigSocialBoosts from './gig-social-boosts'
import languageLevels from './language-levels'
import linkedinNewsletter from './linkedin-newsletter'
import mentorship from './mentorship'
import perks from './perks'
import personalityTests from './personality-tests'
import professionalSituations from './professional-situations'
import recruiterProspects from './recruiter-prospects'
import requests from './requests'
import resumes from './resumes'
import salary from './salary'
import selectionProcesses from './selection-processes'
import salaryTaxRates from './salary-tax-rates'
import salaryInsightTextCategories from './salary-insight-text-categories'
import salaryInsightTexts from './salary-insight-texts'
import urlChecker from './url-checker'
import vacancies from './vacancies'
import widgets from './widget'
import workAvailabilities from './work-availabilities'
import workHours from './work-hours'
import workMethodologies from './work-methodologies'

const jobs = [
	{
		path: '/jobs/dashboard',
		name: 'jobs-dashboard',
		component: () => import('@/views/jobs/dashboard/Index.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,application',
		},
	},
	{
		path: '/jobs/applications',
		name: 'jobs-applications-list',
		component: () => import('@/views/jobs/applications/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,application',
		},
	},
	{
		path: '/jobs/institutions',
		name: 'institutions',
		component: () => import('@/views/institutions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,education-levels',
		},
	},
	{
		path: '/jobs/messages',
		name: 'jobs-messages-list',
		component: () => import('@/views/messages/Messages.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,messages',
		},
	},
	{
		path: '/jobs/newsletter',
		name: 'jobs-newsletter-list',
		component: () => import('@/views/newsletters/Newsletter.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,newsletter',
		},
	},
	{
		path: '/jobs/notifications',
		name: 'jobs-notifications-list',
		component: () => import('@/views/notifications/Notifications.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,notifications',
		},
	},
	...linkedinNewsletter,
	...resumes,
	...requests,
	...vacancies,
	...educationLevels,
	...employments,
	...experiences,
	...gamingJobSuggestions,
	...gigCategories,
	...gigDisputes,
	...gigListings,
	...gigNegotiations,
	...gigProposalPayouts,
	...gigReviewContests,
	...gigSocialBoosts,
	...salary,
	...selectionProcesses,
	...salaryTaxRates,
	...salaryInsightTextCategories,
	...salaryInsightTexts,
	...workHours,
	...perks,
	...workMethodologies,
	...workAvailabilities,
	...languageLevels,
	...professionalSituations,
	...application,
	...widgets,
	...mentorship,
	...personalityTests,
	...urlChecker,
	...recruiterProspects,
]

export default jobs
